<template>
  <div class="py-4 container-fluid">
    <div class="row mb-4">
      <div class="col-lg-12 position-relative z-index-2">
        <div class="row">
          <div class="col-lg-3 col-md-6 col-sm-6">
            <mini-statistics-card
              :title="{ text: 'Total Invoices', value: stats.total_invoice_amount ?? 0.0 }"
              detail="Sum of all invoice total"
              :icon="{
                name: 'money',
                color: 'text-white',
                background: 'primary',
              }"
            />
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6 mt-lg-0 mt-4">
            <mini-statistics-card
              :title="{ text: 'Paid Invoice', value: stats?.paid_invoice ?? 0.0 }"
              detail="Count of all paid invoices "
              :icon="{
                name: 'leaderboard',
                color: 'text-white',
                background: 'success',
              }"
            />
          </div>
<!--                 detail="<span class='text-success text-sm font-weight-bolder'>+3%</span> than last month"-->
          <div class="col-lg-3 col-md-6 col-sm-6 mt-lg-0 mt-4">
            <mini-statistics-card
              :title="{ text: 'Close Expires', value: stats.expiring_invoice_count }"
              detail="Expiring in <span class='text-danger text-sm font-weight-bolder'>30 days</span> "
              :icon="{
                name: 'schedule',
                color: 'text-white',
                background: 'danger',
              }"
            />
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6 mt-lg-0 mt-4">
            <mini-statistics-card
              :title="{ text: 'Total Customers', value: stats.customers_count }"
              detail="Just a count of all customers"
              :icon="{
                name: 'people',
                color: 'text-white',
                background: 'info'
              }"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MiniStatisticsCard from "./components/MiniStatisticsCard.vue";
import logoXD from "@/assets/img/small-logos/logo-xd.svg";
import logoAtlassian from "@/assets/img/small-logos/logo-atlassian.svg";
import logoSlack from "@/assets/img/small-logos/logo-slack.svg";
import logoSpotify from "@/assets/img/small-logos/logo-spotify.svg";
import logoJira from "@/assets/img/small-logos/logo-jira.svg";
import logoInvision from "@/assets/img/small-logos/logo-invision.svg";
import team1 from "@/assets/img/team-1.jpg";
import team2 from "@/assets/img/team-2.jpg";
import team3 from "@/assets/img/team-3.jpg";
import team4 from "@/assets/img/team-4.jpg";
import axios from "axios";
import authHeader from "@/services/auth-header.js";
import showSwal from "@/mixins/showSwal.js";
export default {
  name: "dashboard-default",
  data() {
    return {
      logoXD,
      team1,
      team2,
      team3,
      team4,
      logoAtlassian,
      logoSlack,
      logoSpotify,
      logoJira,
      logoInvision,
      stats: {}
    };
  },
  components: {
    MiniStatisticsCard,
  },
  methods: {
        showMessage(type, message) {
          showSwal.methods.showSwal({
              type,
              message,
              width: 500
          });
      },
    async fetchStats() {
      try {
        const API_URL = process.env.VUE_APP_API_BASE_URL;
        const {data} = await axios.get(`${API_URL}/stats/`, {
          headers: authHeader(),
        });
        this.stats = data.data
        console.log('stat', this.stats)
      } catch (error) {
         if (error.status === 401) {
            this.showMessage('error', 'Login required')
            await this.$router.push('/login')
          }
          console.error(error)
        // showMessage('error', 'Failed to load policy data.');
      }
    }
  },
  mounted() {
    this.fetchStats()
  }
};
</script>
